/**
 * The nav badge and the My Work chip (punch item 1.6).
 *
 * One request, one definition. The bell and the bottom-nav pill both rendered a
 * hardcoded `0` — a number the app was inventing — and the counts they should
 * have shown already existed inside the expirations query the /work lanes run.
 * So `/api/v1/me/badges` returns those, and this hook is the only client-side
 * reader of them.
 *
 * Refetched on mount and left alone otherwise: this is an ambient number, not a
 * live ticker. Polling it would put a query on every screen for a value that
 * changes when the reader themselves closes an item — which invalidates it
 * explicitly (see `useCloseKeyDate`'s cache work).
 */

import type { BadgeCounts } from '@propos/shared';
import { useQuery } from '@tanstack/react-query';

import { api } from './api.js';

export const BADGES_KEY = ['badges'] as const;

export function useBadges(): { readonly counts: BadgeCounts | undefined } {
  const query = useQuery({
    queryKey: BADGES_KEY,
    queryFn: () => api<BadgeCounts>('/api/v1/me/badges'),
  });
  return { counts: query.data };
}
